'use strict';

yalwa.vap = (function(pub) {

	let load_indie_flow_once;
	let vip_init_once;
	var sticky_threshold;
	var button_state_visible = false;
	pub = pub || {};

	pub.map = null;
	pub.latitude = null;
	pub.longitude = null;
	pub.partner_url = false;
	
	pub.init = function() {
		jQuery(window).on('pageshow', event => {
			if (yalwa.basics.is_back_forward_navigation(event.originalEvent)) {
				// if user come from the before ad
				// the position of the main col is translated 100% of left so
				// reset the main_col position
				jQuery('.js-main_col').css('transform', 'initial');
			}
		});
		init_slick();
		init_obfuscated_data();
		init_vip();
		init_managead();
		init_flagging();
		init_contact();
		jQuery('.js-get_browsepage_url').on('click', get_browsepage_url_handler);
		if (!yalwa.basics.ls_get('prev_was_bsp')) {
			yalwa.basics.show(jQuery('.js-headroom_last_bsp'));
		}
		yalwa.mobile.email_alerts_init();

		if (yalwa.basics.unix() < yalwa.basics.ls_get('vap_contact') + 60 && yalwa.basics.is_logged_in()) {
			jQuery('.js-contact_advertiser:first').trigger('click');
			yalwa.basics.ls_remove('vap_contact');
		} else {
			yalwa.basics.ls_remove('vap_contact_message');
		}

		if (yalwa.basics.unix() < yalwa.basics.ls_get('vap_offer') + 60 && yalwa.basics.is_logged_in()) {
			jQuery('.js-contact_offer:first').trigger('click');
			yalwa.basics.ls_remove('vap_offer');
		} else {
			yalwa.basics.ls_remove('vap_offer_value');
		}

		jQuery('.js-reveal_website').on('click', () => {
			yalwa.mobile.load_pa_plan_overlay('paf_website_phone');
		});

		if (jQuery('.js-contact_buttons_sticky').length) {
			sticky_threshold = calc_sticky_threshold();
			jQuery(window).on('scroll.check_buttons', yalwa.basics.throttle(scroll_check_buttons, 10));
		}

		jQuery('.js-really_delete').on('click', function(e) {
			e.preventDefault();
			var url = jQuery(this).attr('href');
			jQuery('.js-really_delete_plp').trigger('plp_show').on('plp_confirm', function() {
				yalwa.basics.navigate(url);
			});
			return false;
		});
		yalwa.basics.state.register('contact_form', pagepop_contact_form);
		window.setTimeout(function() {
			if (yalwa.v.image_featured) {
				jQuery('.js-vip_shadow,.js-toggle_vip').trigger('click');
			}
		}, 400);
		jQuery('.js-snh_category').on('click', function() {
			if (jQuery(this).hasClass('toggled')) {
				jQuery('.js-headroom').css({overflow: 'visible'});
			} else {
				jQuery('.js-headroom').css({overflow: ''});
			}
		});
		next_float_button();
		touchpoint_prepare();
		if (yalwa.v.dolteaser) {
			init_dolteaser_image_overlay_click_handler();
		}
		safer_trading_init();
		setTimeout(check_empty_promo, 1000);
		init_arrow_navigation();
		init_conversation_limit_reached();
		pub.swiping.init();
		
		jQuery('.js-open_pa_dialog').on('click', () => {
			yalwa.mobile.load_pa_plan_overlay('paf_website_phone');
		});
	};
	
	function init_arrow_navigation() {
		jQuery(document).on('keydown', function(event) {
			if (event.which !== 37 && event.which !== 39) {
				return;
			}
			const direction = event.which === 37 ? 'left' : 'right';
			if (jQuery('.js-vip_wrap:visible').length) {
				jQuery('.js-vip_' + direction).trigger('click');
			} else {
				let href = jQuery('.js-vap_navigate_' + direction).attr('href');
				if (href && href.length) {
					yalwa.basics.navigate(href);
				}
			}
		});
	}
	
	function check_empty_promo() {
		if (jQuery('.promo_top_big').length && jQuery('.promo_top_big').is(':visible') && !jQuery('.promo_top_big').height()) {
			jQuery('.promo_top_big').parent().remove();
		}
	}
	
	function safer_trading_init() {
		const $tips = jQuery('.js-safer_trading_tip');
		jQuery('.js-tip_prev,.js-tip_next').on('click', function() {
			const forward = jQuery(this).hasClass('js-tip_next');
			let current = $tips.not('.hidden').index();
			let next = forward ? current + 1 : current - 1;
			if (next > $tips.length - 1) {
				next = 0;
			}
			if (next < 0) {
				next = $tips.length - 1;
			}
			jQuery('.js-tip_index').text(next + 1);
			$tips.addClass('hidden');
			$tips.eq(next).removeClass('hidden');
		});
	}
	
	function touchpoint_prepare() {
		jQuery(window).on('pageshow', event => {
			let navigation_entry = window.performance.getEntriesByType('navigation')[0];
			let nav_type = navigation_entry ? navigation_entry.type : null;
			let tp = 'navigate';
			if (event.persisted || (event.originalEvent && event.originalEvent.persisted)) {
				tp = 'bfcache';
			} else if (nav_type === 'back_forward') {
				tp = 'back_forward';
			} else if (nav_type === 'reload') {
				tp = 'reload';
			}
			if (tp === 'bfcache') {
				touchpoint_track(tp);
			}
		});
	}

	function touchpoint_track(tp) {
		yalwa.basics.beacon('/api/ajax/track/', {
			t: 'vap_origin',
			origin: tp ? tp : 'unknown',
			pagetype_before: yalwa.basics.ga.pagetype_before_preserved()
		});
	}
	
	function get_browsepage_url_handler() {
		const msgID = jQuery(this).data('msgid');
		jQuery.ajax({
			url: '/api/ajax/general',
			type: 'get',
			dataType: 'json',
			cache: false,
			data: {
				action: 'get_browsepage_url',
				msgID: msgID
			}
		}).done(function(response){
			if (response.url) {
				yalwa.basics.navigate(response.url);
			} else {
				// show something went wrong message
			}
		}).fail(function(e){
			// show something went wrong message
		});
	}

	function calc_sticky_threshold() {
		const tmp = yalwa.mobile.mainscroll_get();
		yalwa.mobile.mainscroll_set(0);
		let threshold = null;
		if (jQuery('.js-contact_buttons_static').length) {
			threshold = parseFloat(jQuery('.js-contact_buttons_static').offset().top);
			threshold -= parseFloat(jQuery('.js-headroom').height() - (jQuery('.js-htabs_cats').outerHeight() || 0) + 1);
		}
		yalwa.mobile.mainscroll_set(tmp);
		return threshold;
	}

	function scroll_check_buttons() {
		if (sticky_threshold === null) {
			return;
		}
		const pos = yalwa.mobile.mainscroll_get();
		if (pos > sticky_threshold && !button_state_visible && !vapi_is_open()) {
			button_state_visible = true;
			jQuery('.js-contact_buttons_sticky_floating').css({top: jQuery('.js-headroom').height() - (jQuery('.js-htabs_cats').outerHeight() || 0)});
			yalwa.basics.show(jQuery('.js-contact_buttons_sticky'));
		} else if (pos <= sticky_threshold && button_state_visible) {
			button_state_visible = false;
			yalwa.basics.hide(jQuery('.js-contact_buttons_sticky'));
		}
	}

	function get_and_open_partner_link(msgID) {
		if (!yalwa.vap.partner_url) {
			jQuery.ajax({
				url: '/api/ajax/get_url/',
				data: {
					msgID: msgID
				},
				success: partner_link_response
			});
		} else {
			open_partner_url(yalwa.vap.partner_url, false);
		}
	}

	function partner_link_response(response) {
		if (response) {
			yalwa.vap.partner_url = response;
			open_partner_url(response);
		} else {
			jQuery('.js-contact_buttons').remove();
			// yalwa.basics.sentry.submit_error(new Error('Couldn\'t get external link for partner'));
		}
	}

	function open_partner_url(url) {
		yalwa.basics.new_tab(url);
	}

	function pagepop_contact_form() {
		if (jQuery('.js-contact_dialog').is(':visible')) {
			hide_contact_form();
			return true;
		}
	}

	function contact_form_request(offer) {
		yalwa.basics.state.push('contact_form');
		yalwa.basics.ga.ping_metric('CM_VAP_CONTACT_FORM', 1);
		jQuery.post(
			'/api/ajax/chat/',
			{
				action: 'contact_form',
				msgID: yalwa.basics.get_msgID(null, true),
				offer: offer ? 1 : 0
			},
			insert_contact_form
		);
	}

	function contact_offer_click() {
		if (yalwa.v.my_own_ad) {
			contact_form_request(true);
		} else {
			yalwa.basics.chat_limit_reached().done((reached) => {
				if (!reached) {
					contact_form_request(true);
				} else {
					yalwa.mobile.show_chat_limit_reached_plp();
				}
			});
		}
		
	}

	function contact_suggestion_click() {
		var text = jQuery.trim(jQuery(this).text());
		if (yalwa.v.lang.chat_bubble_greeting) {
			text = yalwa.v.lang.chat_bubble_greeting + ' ' + text;
		}
		yalwa.basics.ls_set('vap_contact_message', text);
		jQuery('.js-via_form').eq(0).trigger('click');
		// yalwa.basics.ga.event({category: 'contact suggestions', action: 'click on vap', label: text});
	}

	function contact_advertiser_click() {
		
		var button = jQuery(this);
		if (yalwa.v.ua_phone_verification_needed) {
			yalwa.mobile.show_ua_phone_verification_dialog();
		} else if (button.hasClass('js-via_form')) {
			if (yalwa.v.my_own_ad) {
				contact_form_request();
			} else {
				yalwa.basics.chat_limit_reached().done((reached) => {
					if (!reached) {
						contact_form_request();
					} else {
						yalwa.mobile.show_chat_limit_reached_plp();
					}
				});
			}
		} else if (button.hasClass('js-via_external_link')) {
			yalwa.basics.ga.ping_metric('CM_VAP_CONTACT_EXTERNAL', 1);
			get_and_open_partner_link(yalwa.basics.get_msgID(null, true));
		} else {
			yalwa.basics.sentry.submit_error(new Error('contact button type unspecified'));
		}
	}

	function hide_contact_form() {
		yalwa.mobile.modal_hide();
		yalwa.basics.hide(jQuery('.js-contact_dialog'));
		jQuery('.js-generic_shadow').off('click.contact');
		yalwa.mobile.generic_shadow.hide(true);
		yalwa.basics.emoji.picker_close();
	}

	function show_contact_form() {
		var $dialog = jQuery('.js-contact_dialog');
		yalwa.mobile.modal_show();

		yalwa.basics.show($dialog);

		yalwa.mobile.generic_shadow.show();
		jQuery('.js-generic_shadow').on('click.contact', function() {
			if (jQuery('.js-contact_email').is(':visible')) {
				if (confirm(yalwa.v.lang.delete_message_warning)) {
					hide_contact_form();
				}
			} else {
				hide_contact_form();
			}
		});
		$dialog.find('input,textarea').filter(':visible').eq(0).focus();
	}

	function contact_suggestion_click_dialog() {
		var $this = jQuery(this);
		var text = jQuery.trim($this.text());
		if (yalwa.v.lang.chat_bubble_greeting) {
			text = yalwa.v.lang.chat_bubble_greeting + ' ' + text;
		}
		yalwa.basics.ls_set('vap_contact_message', text);
		jQuery('.js-contact_message').val(yalwa.basics.ls_get('vap_contact_message'));
		yalwa.basics.ga.event({category: 'contact suggestions', action: 'click in dialog', label: text});
	}

	function is_offer_valid() {
		const value = jQuery('.js-vap_offer_input').val();
		if (!value) {
			return false;
		}
		if (value.match(/^\d+([\.,]\d+)?$/)) {
			const value_amount = value.replace(',', '.');
			return parseFloat(value_amount) >= 0.01;
		} else {
			return false;
		}
	}

	function is_offer_contact_form() {
		return jQuery('.js-contact_form').hasClass('js-offer_contact_form');
	}

	function insert_contact_form(response) {
		jQuery('.js-contact_form').remove();
		jQuery('.js-contact_append').append(response);
		if (yalwa.basics.ls_get('vap_contact_message') && !jQuery('.js-contact_message').val()) {
			jQuery('.js-contact_message').val(yalwa.basics.ls_get('vap_contact_message'));
		}
		jQuery('.js-contact_message').on('focus', function() {
			yalwa.basics.emoji.picker_close();
		});
		if (yalwa.basics.ls_get('vap_offer_value') && !jQuery('.js-vap_offer_input').val()) {
			jQuery('.js-vap_offer_input').val(yalwa.basics.ls_get('vap_offer_value'));
		}
		jQuery('.js-send').on('click', send_contact_mail);
		show_contact_form();
		yalwa.mobile.carousel.init();
		jQuery('.js-emojione_open_list').one('click', function() {
			if (!jQuery('.js-emojilist').length) {
				yalwa.basics.emoji.picker_init(jQuery('.js-contact_dialog')).done(function() {
					jQuery('.js-emojilist').on('click', '.js-emojione', on_emojilist_pick);
					if (jQuery('.js-contact_suggestion').length) {
						jQuery('.js-emojilist').addClass('emojilist--bubbles');
					}
				});
			}
		});
		jQuery('.js-emojione_open_list').on('click', function() {
			yalwa.basics.emoji.picker_toggle();
			if (jQuery('.js-emojilist').hasClass('hidden')) {
				jQuery('.js-contact_dialog').removeClass('contact_dialog--down');
			} else {
				jQuery('.js-contact_dialog').addClass('contact_dialog--down');
			}
			// if (jQuery('.js-contact_dialog').hasClass('contact_dialog--centered')) {
			// 	jQuery.Velocity.hook(jQuery('.js-contact_dialog'), 'translateY', '0%');
			// }
		});
		jQuery('.js-contact_dialog .js-contact_suggestion').on('click', contact_suggestion_click_dialog);
		jQuery('.js-contact_append').find('form').on('submit', function(e) {
			jQuery(this).find('.js-send').trigger('click'); // avoid traditional submitting e.g. when pressing enter in input field
			e.preventDefault();
		});
	}

	function trigger_userprofile_follow() {
		const $follow_action = jQuery('.js-userprofile_vap .js-profile_action[data-action="follow"]').first();

		if ($follow_action.length) {
			$follow_action.trigger('click', 'via_contact_form');
			return;
		}

		const userID = jQuery('.js-follow-user-btn').data('userid') || yalwa.v.userID_viewed;
		if (userID) {
			jQuery.post('/api/ajax/follow_user', {
				action: 'follow',
				userID: userID,
				msgID: yalwa.basics.get_msgID(null, true)
			});
		}
	}
	
	function on_emojilist_pick() {
		var $t = jQuery('.js-contact_message');
		$t.val($t.val() + jQuery(this).attr('alt'));
		yalwa.basics.emoji.picker_close();
	}

	function is_valid(element) {
		if (typeof (element.validity) !== 'undefined' && !element.validity.valid) {
			var $element = jQuery(element);
			$element.addClass('indicate_validity');
			return $element.data('validation_message') ? $element.data('validation_message') : element.validationMessage;
		}
	}

	function only_unique(value, index, self) { // http://stackoverflow.com/a/14438954/333864
		return self.indexOf(value) === index;
	}

	function remove_indicate_validity() {
		jQuery('.indicate_validity').removeClass('indicate_validity');
	}

	function check_contact_form_validity($input) {
		var invalid = jQuery.map($input, is_valid).filter(only_unique);
		for (var i = 0; i < invalid.length; i++) {
			yalwa.basics.toast({message: invalid[i], type: 'error'});
		}
		window.setTimeout(remove_indicate_validity, 5000);
		if (invalid.length) {
			return false;
		}
		return true;
	}

	var last_contact_form_follow_checked = false;
	function send_contact_mail(e) {
		if (!yalwa.basics.readonly_check()) {
			return false;
		}
		yalwa.basics.emoji.picker_close();
		if (is_offer_contact_form()) {
			if (!is_offer_valid()) {
				jQuery('.js-vap_offer_input').parent().velocity('callout.pulse');
				return false;
			}
		}
		if (!check_contact_form_validity(jQuery('.js-contact_message'))) {
			return;
		}
		if (yalwa.basics.is_logged_in()) {
			yalwa.basics.ga.event({
				category: 'vap_contact',
				action: 'logged-in: contacted',
			});
			const $form = jQuery(this).closest('form');
			last_contact_form_follow_checked = $form.find('.js-contact_follow').is(':checked');
			contact_request();
		} else {
			hide_contact_form();
			yalwa.basics.ga.event({
				category: 'vap_contact',
				action: 'logged-out: plp shown',
			});
			if (jQuery(this).closest('.js-offer_contact_form').length) {
				yalwa.basics.ls_set('vap_offer_value', jQuery('.js-vap_offer_input').val());
				yalwa.basics.ls_set('vap_offer', yalwa.basics.unix());
			} else {
				yalwa.basics.ls_set('vap_contact', yalwa.basics.unix());
				yalwa.basics.ls_set('vap_contact_message', jQuery('.js-contact_message').val());
			}
			yalwa.mobile.auth.show_dialog(e);
		}
		return false;
	}


	function contact_request() {
		const $form = jQuery('.js-contact_form');
		const obj = {};
		jQuery($form.serializeArray()).each(function(i, j){
			obj[j.name] = j.value;
		});
		jQuery.ajax({
			url: $form.attr('action'),
			data: obj,
			dataType: 'json',
			type: 'POST'
		}).done(function(response) {
			if (response.class === 'success') {
				yalwa.basics.track_vap_contact();
			}
			contact_response(response, obj);
		});
	}

	function contact_response(response, data) {
		if (response['class'] != 'error') {
			if (jQuery('.js-contact_buttons_sticky').length) {
				jQuery('.js-contact_advertiser,.js-contact_offer').off('click');//.addClass('contact_buttons__button--disabled');
			} else {
				jQuery('.js-contact_advertiser').closest('div').remove();
			}
		}
		yalwa.basics.hide(jQuery('.js-contact_suggestions'));
		hide_contact_form();
		switch (response['class']) {
			case 'error':
				yalwa.basics.toast({message: response.label, 'type': 'error'});
				break;
			case 'success_confirm':
				yalwa.basics.toast({
					message: response.label,
					type: 'info',
					progressBar: true,
					positionClass: "toast-top-full-width",
					timeOut: 10000
				});
				break;
			case 'success':
				if (jQuery('.js-plp_nudge_after_msg_sent').length) {
					init_after_msg_sent_nudge();
				} else {
					yalwa.basics.toast({
                        message: response.label,
                        'type': 'success',
                        progressBar: true,
                        positionClass: "toast-top-full-width",
                        timeOut: 5000
                    });
				}
				if (last_contact_form_follow_checked) {
					trigger_userprofile_follow();
				}
				const $contact_advertiser = jQuery('.js-contact_advertiser');
				$contact_advertiser.html('<span>' + response.label + '</span>').addClass('ysb-action');
				break;
			case 'error_login':
				yalwa.mobile.auth.register_success_handler(contact_request).show_dialog();
				break;
		}
		return false;
	}

	function init_after_msg_sent_nudge() {
		const $nudge = jQuery('.js-plp_nudge_after_msg_sent');
		// show the nudge
		if (last_contact_form_follow_checked) {
			yalwa.basics.show(jQuery('.js-nudge_chat_subtitle, .js-nudge_chat_subtitle_hr'));
		} else {
			yalwa.basics.hide(jQuery('.js-nudge_chat_subtitle, .js-nudge_chat_subtitle_hr'));
		}
		const is_mobile = yalwa.basics.current_device_classification() === 'mobile';
		if (is_mobile) {
			let $show_more = jQuery('.js-nudge_show_more');
			yalwa.basics.show($show_more);
			$show_more.on('click', function() {
				yalwa.basics.hide($show_more);
				yalwa.basics.show(jQuery('.js-nudge_related_ad_link'));
			});
		} else {
			yalwa.basics.hide(jQuery('.js-nudge_show_more'));
			yalwa.basics.show(jQuery('.js-nudge_related_ad_link'));
		}
		jQuery('.js-plp_container').addClass('plp_container--center');
		$nudge.trigger('plp_show');
	}

	function get_login_url() {
		return yalwa.basics.login_url();
	}
	
	function load_indie_flow() {
		yalwa.basics.load_css(yalwa.basics.static_url('css') + 'fonts/indie_flower/style.css');
	}
	
	function vapi_is_open() {
		return jQuery('.js-vip_container').length && !jQuery('.js-vip_container').hasClass('hidden');
	}

	function pagepop_vip(e) {
		if (vapi_is_open()) {
			toggle_vip_visible();
			return true;
		}
	}

	function toggle_vip_visible_once() {
		yalwa.basics.state.register('vapi', pagepop_vip);
		if (jQuery('.slick-slide:not(.slick-cloned)').length > 1) {
			jQuery('.js-vip_left,.js-vip_right').on('click', vip_navigate);
		} else {
			yalwa.basics.hide(jQuery('.js-vip_left,.js-vip_right'));
		}
	}

	function vip_navigate() {
		var $this = jQuery(this);
		vip_change($this.hasClass('js-vip_left') ? 'right' : 'left', jQuery('.js-vip_image'));
	}

	function toggle_vip_visible() {
		image_flagging.close();
		var con = jQuery('.js-vip_container');
		if (con.length) {
			load_indie_flow_once = load_indie_flow_once || yalwa.basics.once(load_indie_flow);
  			load_indie_flow_once();
			yalwa.basics.toggle(con);
			if (!con.hasClass('hidden')) {
				yalwa.basics.state.push('vapi');
				var current = jQuery('.slick-active');
				if (!current.length) {
					current = jQuery('.js-user_images__list');
				}
				vip_show(current, 'left', true);
			} else {
				yalwa.basics.state.try_cancel('vapi');
			}
			vip_init_once = vip_init_once || yalwa.basics.once(toggle_vip_visible_once);
			vip_init_once();
		}
	}
	
	function send_ajax_flag(msgID, type, comment) {
		jQuery.ajax({
			url: '/api/ajax/ad_flag/',
			data: {
				action:'flag_ad',
				ID: msgID,
				t: type,
				c: comment,
				csrf: yalwa.v.csrf
			}
		}).done(flagging_thx);
	}

	function flag_button_change() {
		if (jQuery(this).data('flag') == 2) {
			yalwa.basics.show(jQuery('.js-flag_prohibited_space'));
			jQuery('.js-flag_prohibited_submit').off().on('click', function() {
				yalwa.basics.ga.ping_metric('CM_VAP_FLAGGING', 1);
				send_ajax_flag(yalwa.basics.get_msgID(null, true), 2, jQuery('.js-flag_prohibited_text').val());
			});
			return;
		} else {
			yalwa.basics.ga.ping_metric('CM_VAP_FLAGGING', 1);
			send_ajax_flag(yalwa.basics.get_msgID(null, true), jQuery(this).data('flag'), '');
		}
		yalwa.basics.ga.ping_metric('CM_VAP_FLAGGING', 1);
		
	}

	function flagging_thx() {
		yalwa.basics.hide(jQuery('.js-plp_flag_ad__flagging_options'));
		yalwa.basics.hide(jQuery('.js-plp_flag_ad .plp__title'))
		yalwa.basics.show(jQuery('.js-plp_flag_ad__thanks_for_support'));
		setTimeout(function() {
			jQuery('.js-plp_flag_ad').trigger('plp_hide');
		}, 2000);
	}

	function flag_move_suggestions_change() {
		jQuery('.js-flag_ad_dialog').find('.js-flag_ad_dialog__move').slideDown(400);
		return false;
	}

	function flag_cleanup() {
		jQuery('.js-flag_ad_dialog,.js-flag').remove();
	}

	function flag_move_category_change() {
		yalwa.basics.ga.ping_metric('CM_VAP_FLAGGING', 1);
		jQuery.ajax({
			url: '/api/ajax/review/',
			data: {
				id: yalwa.basics.get_msgID(null, true),
				t: jQuery('.js-flag_move_suggestions').val(),
				category: jQuery(this).val(),
				csrf: yalwa.v.csrf
			}
		}).done(flagging_thx);
	}

	function flag_ad_dialog_response(response) {
		if (response.already_flagged) {
			yalwa.basics.debounce(() => {
				yalwa.basics.toast({
					message: response.labels.loc_toaster_msg_flag_ad,
					type: 'warning',
					timeOut: 2000
				});

			}, 500);
		} else {
			jQuery('body').append(response.html);
			yalwa.mobile.check_for_detach();
			const $plp = jQuery('.js-plp_flag_ad');
			$plp.trigger('plp_show');
			yalwa.v.lang.Flagging_Flag_this_ad = response.labels.Flagging_Flag_this_ad;
			yalwa.v.lang.Flagging_thank_you = response.labels.Flagging_thank_you;
			jQuery('.js-generic_shadow').on('click.vap_flag', cancel_flag);
			$plp.find('.js-flag_button').on('change', flag_button_change);
			jQuery('.js-flag_ad_option').on('click', flag_button_change);
			$plp.find('.js-flag_move_suggestions').on('change', flag_move_suggestions_change);
			$plp.find('.js-flag_move_category').on('change', flag_move_category_change);
		}
	}

	function cancel_flag() {
		yalwa.basics.hide(jQuery('.js-flag_ad_dialog'));
		yalwa.mobile.generic_shadow.hide();
		jQuery('.js-generic_shadow').off('click.vap_flag');
	}

	function flag_ad_dialog() {
		jQuery.ajax({
			url: '/api/ajax/ad_flag/',
			data: {
				action: 'load_flagging_options',
				ID: jQuery('.js-flag').data('msgid'),
				catID: jQuery('.js-flag').data('catid')
			},
			dataType: 'json',
			success: flag_ad_dialog_response
		});
	}

	var $slick_current;
	let slick_images, max_index;
	let slick_object;

	function on_slick_load() {
		var user_images = jQuery('.js-user_images__list');
		//https://github.com/kenwheeler/slick/issues/3286
		// changed vertical threshold from 4 to 50 to swipe more easily
		// will be rotated in css
		let $next_arrow = `<div>${yalwa.basics.yimage(1395, {pixel: 36, classes: 'slick-next js-image_click_ignore', alt: yalwa.v.next_img_alt_text})}</div>`;
		let $prev_arrow = `<div>${yalwa.basics.yimage(1395, {pixel: 36, classes: 'slick-prev js-image_click_ignore', alt: yalwa.v.prev_img_alt_text})}</div>`;
		user_images.on('init', function(e,slick) {
			vip_update_numbers(slick.currentSlide);
		})
		user_images.slick({
			dots: false,
			speed: 0,
			fade: true,
			infinite: true,
			slidesToShow: 1,
			centerMode: false,
			variableWidth: false,
			adaptiveHeight: false,
			lazyLoad: 'ondemand',
			arrows: true,
			nextArrow: $next_arrow,
			prevArrow: $prev_arrow,
			touchThreshold: 15
		}).on('afterChange', function(e,slick) {
			vip_update_numbers(slick.currentSlide);
			var really_changed = !$slick_current.is(jQuery('.slick-current'));
			if (really_changed) {
				$slick_current = jQuery('.slick-current');
				vip_track();
			}
		}).on('lazyLoadError', function(event, slick, image, imageSource) {
			if (slick.$slides.length >= 1) {
				let id = jQuery(image).attr('data-id');
				if (id) {
					slick.slickRemove(id);
				}
			} else {
				user_images.remove();
			}
		});
		$slick_current = jQuery('.slick-current');
		user_images.css({visibility: 'visible'}).find('li.hidden').removeClass('hidden');
		user_images.find('img').css({visibility: 'visible'});
		slick_images = jQuery('.slick-slide:not(.slick-cloned)');
		max_index = slick_images.length - 1;
		slick_object = user_images;
	}

	function vip_track() {
		const cd_pagetype = yalwa.v.dolteaser ? 'native_ad2_vip' : 'VIP';
		const app_name = yalwa.v.dolteaser ? 'OTHER' : 'VIP';
		const page = yalwa.v.dolteaser ? '/native_ad2_vip/' : '/VIP/';
		yalwa.basics.ga.dimension_set('CD_PAGETYPE', cd_pagetype);
		yalwa.basics.ga.pageview({'page': page, 'app_name': yalwa.basics.ga.get_updated_pagetype_in_appname(app_name)});
	}

	function init_slick() {
		const $images_container = jQuery('.js-user_images__list');
		const $user_images = $images_container.find('img').not('.yimage');
		if (!$user_images.length) {
			return;
		}
		if ($user_images.length > 1) {
			on_slick_load();
			$user_images.on('click', toggle_vip_visible);
			hammer_ready();
		} else {
			if ($user_images.length === 1) {
				$user_images.css({visibility: 'visible'});
			}
			$images_container.css({visibility: 'visible'}).find('li.hidden').removeClass('hidden');
		}
		jQuery('.js-vip_wrap').on('click', function(e) {
			if (jQuery(e.target).hasClass('js-vip_wrap')) {
				jQuery('.js-vip_container .js-toggle_vip').trigger('click');
			}
		});
	}

	function vip_change(type, e) {
		var slick_images = jQuery('.slick-slide:not(.slick-cloned)');
		var max_index = slick_images.length - 1;
		var current_index = jQuery(e).data('index');
		if (type === 'left') {
			current_index++;
			slick_object.slick('slickNext');
		} else {
			current_index--;
			slick_object.slick('slickPrev');
		}
		if (current_index > max_index) {
			current_index = 0;
		}
		if (current_index < 0) {
			current_index = max_index;
		}
		dolteaser_profile_buttons_visibility_handler(current_index);
		vip_show(slick_images.filter('[data-slick-index="' + current_index + '"]'), type);
		vip_track();
		if (typeof window.adx_slot_popup !== 'undefined') {
			googletag.cmd.push(function() {
				googletag.pubads().refresh([window.adx_slot_popup]);
			});
		}
	}
	
	function dolteaser_profile_buttons_visibility_handler(current_index) {
		const $buttons = jQuery('.js-dolteaser_profile_buttons_vip');
		if (!$buttons.length) {
			return;
		}
		if (current_index === max_index) {
			yalwa.basics.show($buttons);
		} else {
			yalwa.basics.hide($buttons);
		}
	}

	function vip_swipe(e) {
		vip_change(e.type === 'swipeleft' ? 'left' : 'right', jQuery('.js-vip_image')[0]);
	}

	function hammer_ready() {
		var mc = new Hammer(jQuery('.js-vip_wrap')[0]);
		mc.on('swipeleft swiperight', vip_swipe);
	}

	function vip_create_and_append(current) {
		var img = current.find('img');
		const data_index = (current.data('slick-index') || 0);
		const external_class = img.hasClass('js-user_images_ext') ? ' vip_modal__img--external' : '';
		const $new = jQuery('<img>', {
			class: 'js-vip_image vip_modal__img hidden' + external_class,
			'data-index': data_index,
			alt: img.attr('alt') || ''
		});
		let src = img.attr('src') || img.data('src') || img.data('lazy') || '';
		if (img.data('external_image_source')) {
			src = img.data('external_image_source');
		} else {
			const srcset = img.attr('srcset');
			if (srcset) {
				$new.attr('srcset', srcset);
			}
			const sizes = img.attr('data-vip_sizes');
			if (sizes) {
				$new.attr('sizes', sizes);
			}
		}
		if (src) {
			$new.attr('src', src);
		}
		if (yalwa.v.dolteaser_blurred_images) {
			$new.addClass('flbl');
		}
		jQuery('.js-vip_wrap').html($new);
		return $new;
	}

	
	function vip_show(current, type, init) {
		var $new = vip_create_and_append(current);
		jQuery('.js-vip_container').find('.js-vip_image').hide(0, function() {
			if (init) {
				vip_track();
			}
			if (!init) {
				jQuery(this).filter(':not(.hidden)').remove();
			}
			$new.show(0);
			yalwa.basics.show($new);
			// small fix for iOS where the img doesn't grow to the container height apparently
			// jQuery('.js-vip_image').css({minHeight: jQuery('.js-vip_wrap').height()});
		});

		var current_index = current.data('slick-index');
		dolteaser_profile_buttons_visibility_handler(current_index);
		pub.current_index = (current_index || 0) + 1;
		vip_update_numbers(current_index);
		vip_update_share_buttons(current_index);
	}

	function vip_update_numbers(current_index) {
		jQuery('.js-vip_position').text(((current_index || 0) + 1) + ' / ' + (jQuery('.slick-slide:not(.slick-cloned)').length || 1));
	}

	function vip_update_share_buttons(current_index) {
		jQuery('.js-vip_container .js-share_buttons').data('current_index', (current_index || 0) + 1);
		jQuery('.js-vip_container .js-share_buttons a').each(function(index, link) {
			var tmp = (current_index || 0) + 1;
			var $link = jQuery(link);
			var href = $link.attr('href');
			href = href.replace(/%2526image_featured%253D[0-9]+/ig, '');
			if (tmp > 0) {
				if ($link.data('provider') === 'WhatsApp') {
					href = href.replace(/%26p%3Dwhatsapp+/ig, '');
					var regex = /(?:lcn|locan)\.to(.*?)$/;
					var m = regex.exec(href);
					if (m !== null) {
						var regex_id = /(.*?)%2526i%253D(.*?)$/;
						var n = regex_id.exec(m[1]);
						if (n !== null) {
							href = href.replace(m[1], n[1] + encodeURIComponent('%26i%3D') + tmp);
						} else {
							href = href.replace(m[1], m[1] + encodeURIComponent('%26i%3D') + tmp);
						}
					}
					href = href + '%26p%3Dwhatsapp';
				} else if ($link.data('provider') === 'Twitter') {
					var regex = /(?:lcn|locan)\.to(.*?)&/;
					var m = regex.exec(href);
					if (m !== null) {
						var regex_id = /(.*?)%2526i%253D(.*?)$/;
						var n = regex_id.exec(m[1]);
						if (n !== null) {
							href = href.replace(m[1], n[1] + encodeURIComponent('%26i%3D') + tmp);
						} else {
							href = href.replace(m[1], m[1] + encodeURIComponent('%26i%3D') + tmp);
						}
					}
				} else {
					href = href.replace(/\.html/ig, encodeURIComponent('.html%26image_featured%3D') + tmp);
				}
			}
			$link.attr('href', href);
		});
	}

	function reveal(reveal_button) {
		let $this = jQuery('.js-obf');

		return yalwa.basics.ajaxservice({
			type: 'POST',
			resource: 'posting',
			action: 'reveal_phone',
			identifier: yalwa.basics.get_msgID(null, true),
			data: {
				c: $this.data('code'),
				k: $this.data('key'),
				call_button: reveal_button ? 'vap_call' : 0,
			},
			csrf: $this.data('csrf'),
			include_session: true,
			is_cross_origin: true
		});
	}

	function init_conversation_limit_reached() {
		jQuery(() => {
			if (jQuery('.js-limit_reached_banner').length) {
				yalwa.basics.ga.datalayer({
					event: 'premium_account_vap_banner',
					premium_account_vap_banner: 'banner_upgrade_view'
				});
			}
		});
		
		if (jQuery('.js-pa_limit_reached_text').length) {
			jQuery('.js-limit_reached_banner').on('click', function() {
				yalwa.basics.ga.datalayer({
					event: 'premium_account_vap_banner',
					premium_account_vap_banner: 'banner_upgrade_click'
				});
				const url = jQuery(this).data('url');
				if (yalwa.mobile.is_mobile_width()) {
					yalwa.basics.navigate(url);
				} else {
					yalwa.basics.new_tab(url);
				}
			});
			jQuery('.js-limit_reached_banner a').on('click', function(e) {
				e.preventDefault();
			});
		}
	}

	function viptrack(event) {
		event.preventDefault();
		const $this = jQuery(this);
		const cordova_ios = yalwa.v.is_phonegap && yalwa.v.is_ios;

		yalwa.basics.ajaxservice({
			type: 'PUT',
			resource: 'vip',
			action: 'url_click',
			identifier: yalwa.basics.get_msgID(),
			csrf: $this.data('vip')
		}).then((response) => {
			yalwa.basics.new_tab($this.attr('href'));
		});

		$this.off('click');
	}

	function reveal_wrap() {		
		reveal().then(function(response) {
			yalwa.basics.ga.event({
				category: 'reveal_number',
				action: 'logged-in: revealed'
			});
			if (response && response.success) {
				reveal_success_handler(response);
			}
		});
	}
	function reveal_success_handler(response) {
		const $obf = jQuery('.js-obf');
		const $response = jQuery(response.html).addClass('js-revealed_number').addClass('js-obf');
		// Preserve data attributes
		const dataAttributes = $obf.data();
		const note = $obf.parent().css({position: 'relative'}).data('note');
		if (note) {
			$response.after('<span class="tip js-tip_temp">' + note + '</span>');
		}
		$obf.replaceWith($response);
		$response.attr('data-code', dataAttributes.code);
		$response.attr('data-key', dataAttributes.key);
		$response.attr('data-csrf', dataAttributes.csrf);
		window.setTimeout(function() {
			jQuery('.js-tip_temp').remove();
		}, 8000);
	}
	
	function reveal_after_login() {
		yalwa.basics.ss_remove('reveal');
		if (yalwa.basics.is_logged_in()) {
			reveal_wrap();
		}
	}
	
	
	function reveal_login_success_handler() {
		yalwa.basics.ss_set('reveal', true);
		yalwa.basics.reload();
	}
	function call_after_login() {
		yalwa.basics.ss_remove('call');
		if (yalwa.basics.is_logged_in()) {
			call();
		}
	}
	function call_login_success_handler() {
		yalwa.basics.ss_set('call', true);
		yalwa.basics.reload();
	}


	function init_obfuscated_data() {
		if (yalwa.basics.ss_get('reveal')) {
			reveal_after_login();
		}
		if (yalwa.basics.ss_get('call')) {
			call_after_login();
		}
		jQuery('.js-obf').on('click', function(e) {
			e.preventDefault();
			if (!yalwa.basics.is_logged_in()) {
				yalwa.basics.ga.event({
					category: 'reveal_number',
					action: 'logged-out: plp shown',
				});
				yalwa.mobile.auth.register_success_handler(reveal_login_success_handler).show_dialog(e);
				return false;
			}
			reveal_wrap();
			return false;
		}).parent().show();
		jQuery('.js-vap_call').on('click', function(e) {
			e.preventDefault();
			if (!yalwa.basics.is_logged_in()) {
				yalwa.basics.ga.event({
					category: 'vap_call',
					action: 'logged-out: plp shown',
				});
				yalwa.mobile.auth.register_success_handler(call_login_success_handler).show_dialog(e);
				call();
				return false;
			}
			call();
			return false;
		});
		jQuery('.js-viptrack').not('.js-external_links').on('click', viptrack);
		jQuery('.js-phone_number_reveal_extender').on('click', extend_obf_click);
	}
	
	function call() {
		var $this = jQuery('.js-vap_call');
		yalwa.basics.ga.ping_metric('CM_VAP_CALL', 1);
		if (jQuery('.js-revealed_number').length) {
			reveal(true);
			$this.attr('href', 'tel:' + jQuery('.js-revealed_number').text());
			yalwa.basics.navigate($this.attr('href'));
		} else {
			reveal(true).then(function(response) {
				if (response && response.success) {
					$this.attr('href', 'tel:' + jQuery(response.html).text());
					yalwa.basics.navigate($this.attr('href'));
				}
			});
		}
	}
	
	function extend_obf_click() {
		jQuery('.js-obf').trigger('click');
	}

	function init_vip() {
		var $vip_container = jQuery('.js-vip_container');
		if ($vip_container.length) {
			$vip_container.detach().appendTo(jQuery('body'));
			jQuery('.js-vip_shadow,.js-toggle_vip').on('click', toggle_vip_visible);

			var user_images = jQuery('.js-user_images__list');
			if (user_images.find('img').length) {
				user_images.on('click', function(e) {
					if (
						!jQuery(e.target).closest('button,img').length && // dots
						!jQuery(e.target).hasClass('js-image_click_ignore') // arrows
					) {
						toggle_vip_visible();
					}
				});
				if (user_images.find('img').not('.js-image_click_ignore').length === 1) {
					user_images.find('img').on('click', toggle_vip_visible);
				}
			}
			image_flagging.init();
		}
	}

	let image_flagging = (function(pub) {

		pub = pub || {};

		pub.init = function() {
			jQuery('.js-flag_image,.js-vip_flag_modal_close').on('click', toggle_modal);
			jQuery('.js-vip_flag_modal_choose').on('click', choose_type);
			jQuery('.js-vip_flag_modal_back').on('click', modal_back);
			jQuery('.js-vip_flag_modal_go').on('click', submit_copyright);
		};

		pub.close = function() {
			yalwa.basics.hide(jQuery('.js-vip_flag_modal'));
		};

		function modal_back() {
			yalwa.basics.hide(jQuery('.js-vip_flag_copyright'));
			yalwa.basics.show(jQuery('.js-vip_flag_modal_list'));
		}

		function choose_type() {
			var $this = jQuery(this);
			var id = $this.data('flag');
			if (id === 3) {
				yalwa.basics.show(jQuery('.js-vip_flag_copyright'));
				yalwa.basics.hide(jQuery('.js-vip_flag_modal_list'));
			} else {
				yalwa.basics.ga.ping_metric('CM_VAP_FLAGGING', 1);
				jQuery.ajax({
					url: '/api/ajax/review/',
					data: {
						action: 'flag_image',
						src: get_image_src(),
						category: yalwa.v.leaf_category,
						reason: $this.data('flag'),
						csrf: yalwa.v.csrf
					},
					success: ajax_response
				});

			}
		}

		function ajax_response(response) {
			yalwa.basics.hide(jQuery('.js-vip_flag_copyright'));
			jQuery('.js-vip_flag_modal_list').replaceWith(response);
			yalwa.basics.hide(jQuery('.js-vip_flag_modal_list'));
			jQuery('.js-vip_flag_modal').velocity('fadeOut', {
				mobileHA: false, delay: 3000, complete: function() {
					jQuery('.js-vip_flag_modal').remove();
					jQuery('.js-flag_image').remove();
				}
			});
		}

		function submit_copyright() {
			var $email = jQuery('.js-vip_flag_input');
			if (!$email.val()) {
				$email.velocity('callout.shake');
				return;
			}
			var $ta = jQuery('.js-vip_flag_textarea');
			if (!$ta.val()) {
				$ta.velocity('callout.shake');
				return;
			}
			yalwa.basics.ga.ping_metric('CM_VAP_FLAGGING', 1);
			jQuery.ajax({
				url: '/api/ajax/review/',
				data: {
					action: 'report_copyright_violation',
					id: yalwa.basics.get_msgID(null, true),
					email: $email.val(),
					src: get_image_src(),
					category: yalwa.v.leaf_category,
					reason: $ta.val(),
					csrf: yalwa.v.csrf
				},
				success: ajax_response
			});
		}

		function get_image_src() {
			return jQuery('.js-vip_image').attr('src').replace(/\/mobile[^\.]*/, '');
		}

		function toggle_modal() {
			yalwa.basics.toggle(jQuery('.js-vip_flag_modal'));
		}

		return pub;

	}());

	function init_managead() {
		jQuery('.js-link').on('click', managead_link);
	}

	function managead_link() {
		yalwa.basics.ga.event({category: 'VAP my links', action: 'mobile', label: jQuery(this).data('target')});
		var $this = jQuery(this);
		window.setTimeout(function() {
			yalwa.basics.navigate($this.attr('href'));
		}, 100);
		return false;
	}

	function init_flagging() {
		jQuery('.js-flag').on('click', flag_ad_dialog);
	}

	function init_contact() {
		jQuery('.js-contact_advertiser_ybtb').on('click', function() {
			jQuery('.js-contact_advertiser:first').trigger('click');
		});
		jQuery('.js-contact_offer_ybtb').on('click', function() {
			jQuery('.js-contact_offer:first').trigger('click');
		});
		jQuery('.js-contact_advertiser').on('click', contact_advertiser_click);
		jQuery('.js-contact_offer').on('click', contact_offer_click);
		jQuery('.js-toggle_contact').on('click', hide_contact_form);
		jQuery('.js-contact_suggestion').on('click', contact_suggestion_click);
	}
	
	function next_float_button() {
		const $button = jQuery('.js-floating_next_button');
		if ($button.length) {
			$button.on('click', () => {
				yalwa.basics.set_VAP_touchpoint('vap_floating_next');
			});
			
			let container = jQuery('.js-main_col');
			let skip_first = true;
			(function floatTimeout(){
				if (skip_first) {
					skip_first = false;
				} else {
					jQuery('.js-floating_next_button_text').toggleClass('hidden');
				}
				setTimeout(floatTimeout, 4000);
			})();
			let scroll_in_progress = false;
			container.on('scroll.ybtb_debounce', function() {
				yalwa.basics.debounce(function(){
					$button.fadeTo( "slow", 1 );
					scroll_in_progress = false;
				}, 500);
			});
			container.on('scroll', yalwa.basics.throttle(function() {
				if (scroll_in_progress == false) {
					$button.fadeTo( "slow", 0.5 );
					scroll_in_progress = true;
				}
			}, 200));
		}
	}
	
	function init_dolteaser_image_overlay_click_handler() {
		const $dol_teaser_image_overlay = jQuery('.js-dolteaser_image_overlay');
		$dol_teaser_image_overlay.on('click', event => {
			event.stopPropagation();
		})
	}
	
	pub.swiping = (function(pub) {
		
		pub = pub || {};
		let touch_start_x = null;
		let touch_start_y = null;
		let is_moving = false;
		let raf_id = null;
		let direction_locked = null;
		let delta_x = null;
		let $main_col;
		let SWIPE_THRESHOLD;
		let allow_forward = false;
		
		pub.init = function() {
			$main_col = jQuery('.js-main_col')
			$main_col[0].addEventListener('pointerdown', on_pointerdown, { passive: true });
			$main_col[0].addEventListener('pointermove', on_pointermove, { passive: false });
			$main_col[0].addEventListener('pointerup',   on_pointerup,  { passive: true });
			$main_col[0].addEventListener('pointercancel', on_pointercancel, { passive: true });
			SWIPE_THRESHOLD = 15;
    		allow_forward = !!jQuery('.js-vap_next').prop('href');
		};
		
		function on_pointercancel() {
			reset_position();
			end_gesture();
		}
		
		function end_gesture() {
			is_moving = false;
			if (raf_id) {
				cancelAnimationFrame(raf_id);
				raf_id = null;
			}
			jQuery('.page_main').css({ overflow: '' });
			touch_start_x = touch_start_y = null;
		}
		
		function check_container_blacklisted(e) {
			return jQuery(e.target).closest('.slick-slider,.js-carousel,.js-contact_suggestions,.js-headroom, .js-breadcrumb_vap').length;
		}
		
		function on_pointerdown(e) {
			if (e.pointerType !== 'touch' || !e.isPrimary) {
				return;
			}
			if (check_container_blacklisted(e)) {
				return;
			}
			if (yalwa.mobile.burger.is_currently_opened()) {
				return;
			}
			jQuery('.page_main').css({ overflow: 'hidden' });
			touch_start_x = e.clientX;
			touch_start_y = e.clientY;
			is_moving = true;
			direction_locked = null;
		}
		
		function update_position() {
			raf_id = null;
			if (is_moving) {
				$main_col.css({transform: delta_x ? `translateX(${delta_x}px)` : ''});
			}
		}
		function reset_position() {
			requestAnimationFrame(() => {
				$main_col.css({transform: ''});
			});
		}
		
		function on_pointermove(e) {
			if (!is_moving || e.pointerType !== 'touch' || !e.isPrimary) {
				return;
			}
			const dx = e.clientX - touch_start_x;
			const dy = e.clientY - touch_start_y;
			// ← bail out immediately on leftward drag if no next href
   			if (dx < 0 && !allow_forward) {
				   return;
			}
			const LOCK_DISTANCE = 2;
			if (!direction_locked && Math.hypot(dx, dy) > LOCK_DISTANCE) {
				direction_locked = Math.abs(dx) > Math.abs(dy) ? 'horizontal' : 'vertical';
			}
			if (direction_locked === 'vertical') {
				return; // let page scroll
			}
			e.preventDefault();
			e.stopPropagation();
			delta_x = dx;
			if (!raf_id) {
				raf_id = requestAnimationFrame(update_position);
			}
		}
		
		function on_pointerup(e) {
			if (!is_moving) {
				return;
			}
			if (e.pointerType !== 'touch' || !e.isPrimary) {
				return;
			}
		
			const diff_x = e.clientX - touch_start_x;
			const diff_y = e.clientY - touch_start_y;
		
			// BLOCKED left‐swipe → snap back
			if (diff_x < 0 && !allow_forward) {
				reset_position();
				end_gesture();
				return;
			}
		
			const x_ok = Math.abs(diff_x) > SWIPE_THRESHOLD;
		
			const allowed_vertical_ratio = 0.8;
			const allowed_vertical = Math.abs(diff_x) * allowed_vertical_ratio;
			const y_ok = Math.abs(diff_y) < allowed_vertical;
		
			if (x_ok && y_ok) {
				const direction = diff_x > 0 ? 'right' : 'left';
				on_swipe(direction);
			} else {
				reset_position();
			}
			end_gesture();
		}
		
		function on_swipe(direction) {
			if (direction === 'left') {
				go_forward();
			} else {
				go_back();
			}
		}
		
		function go_forward() {
			yalwa.basics.ga.event({category: 'vap_swipe', action: 'vap_swipe_next_ad', label: yalwa.basics.is_logged_in() ? 'logged-in' : 'logged-out'});
			yalwa.basics.set_VAP_touchpoint('vap_next');
			$main_col.velocity({translateX: ['-100%', delta_x]}, {duration: 200, complete() {
				yalwa.basics.navigate(jQuery('.js-vap_next').prop('href'));
			}});
		}
		
		function go_back() {
			yalwa.basics.ga.event({category: 'vap_swipe', action: 'vap_swipe_prev_ad', label: yalwa.basics.is_logged_in() ? 'logged-in' : 'logged-out'});
			$main_col.velocity({translateX: ['100%', delta_x]}, { duration: 200, complete() {
				yalwa.basics.state.back();
			}});
		}
		
		return pub;
		
	}(pub.swiping));
	
	return pub;

}(yalwa.vap));

if (yalwa.v.routing === 'vap') {
	yalwa.vap.init();
}
